import { LanguageStrings } from './base-strings';

export const kr: LanguageStrings = {
  /** Routes */
  'routes.appInit': '/',
  'routes.review': '/booking-review',
  'routes.registration': '/registration',
  'routes.confirm': '/confirm',
  'routes.checkinpayment': '/checkinpayment',
  'routes.confirmpayment': '/confirmpayment',
  'routes.hdfForm': '/hdf-form',
  'routes.search': '/search',
  'routes.selectDocumentType': '/select-document-type',
  'routes.takeDocumentPhoto': '/take-document-photo',
  'routes.addGuest': '/add-guest',

  /** Function Name */
  'review.menu.name': '리뷰',
  'hdfForm.menu.name': '건강 신고',
  'registration.menu.name': '등록',
  'confirm.menu.name': '확인',
  'error.menu.name': '오류',
  'search.menu.name': '검색',

  /** Page content */
  'home.title': '홈',
  'home.content': '내 웹사이트에 오신 것을 환영합니다',

  'summary.title': '요약',
  'summary.content':
    '자세한 내용은 아래 링크 {medium} 및 {devto}를 참조하세요.',

  'loading.title': '로딩 중...',
  'loading.content': '예약 세부 정보를 로드하는 중입니다. 잠시 기다려 주세요.',
  'error.title': '오류',
  'error.content': '오류가 발생했습니다. 다시 시도해 주세요.',
  'error.required': '필수 입력 사항입니다.',
  'error.dateOfBirth.day': '유효하지 않은 날짜입니다.',
  'error.message2':
    '시스템 오류가 발생했습니다. 자세한 내용은 시스템 관리자에게 문의해 주세요.',
  'error.message.aleadySubmit':
    '필요한 정보를 이미 등록하셨습니다. 감사합니다!',
  'error.message.notFound': '정보를 찾을 수 없습니다!',
  'error.message.urlInvalid': '링크가 만료되었습니다!',
  'error.message.needReclickUrl': '링크가 만료되었습니다. 다시 클릭해 주세요.',
  'error.message.flightNumber': '항공편 번호 예: CX231',
  'error.message.flightArrivalTime': '유효한 시간을 입력해 주세요.',
  'error.message.preference': '선호 사항을 선택해 주세요.',

  /** Links */
  'links.medium':
    'https://medium.com/prototyped/multi-language-routing-in-react-d7eb7a0688e9',
  'links.dev.to': 'https://dev.to/prototyp/multi-language-routing-in-react-k9l',

  /** Payment T&C */
  'payment.t&c':
    '본인은 이 청구서의 책임을 면제하지 않으며, 이러한 비용을 전액 개인이 부담하는 데 동의합니다.',

  'payment.noPaymentMethod': '사용 가능한 결제 수단이 없습니다.',

  /** Choice Before Pay Room Rate */
  'choice.roomrateTitleOptional':
    '호텔에 도착할 때 체크인 시간을 단축하기 위해 지금 방 요금을 결제하시겠습니까?',
  'choice.roomrateTitleCompulsory':
    '더 빠른 체크인 경험을 위해 방 요금을 미리 결제해 주세요. 감사합니다!',
  'choice.roomrate.no': '아니오, 호텔에 도착할 때 방 요금을 결제하겠습니다.',
  'choice.roomrate.title': '방 요금 세부정보',

  /** Choice */
  'choice.depositTitleOptional':
    '호텔에 도착할 때 체크인 시간을 단축하기 위해 지금 보증금을 결제하시겠습니까?',
  'choice.depositTitleCompulsory':
    '호텔에 도착할 때 체크인 시간을 단축하기 위해 지금 보증금을 결제해 주세요.',
  'choice.yes': '예',
  'choice.no': '아니오, 호텔에 도착할 때 보증금을 결제하겠습니다.',
  'choice.deposit.title': '보증금 세부정보',
  'choice.deposit': '보증금',
  'choice.roomrate': '방 요금',
  'choice.total': '합계',
  'choice.warning': '계속하려면 위의 약관에 동의해야 합니다.',
  'choice.askSaveCreditCard':
    '본인은 호텔이 신용카드에서 상품 및 서비스 관련 비용을 청구하는 것을 허가합니다. 본인은 상인이 향후 결제를 위해 개인 정보를 저장할 수 있다는 것에 동의합니다. 본인은 이 조항이 요청에 따라 언제든지 철회될 수 있음을 이해합니다.',

  /** CheckInPayment */
  'checkinpayment.title': '방 요금 결제해 주세요.',
  'checkinpayment.ok': '좋아요',
  'checkinpayment.selectpaymentmethod': '결제 수단을 선택해 주세요.',
  'checkinpayment.useSavedCard': '저장된 신용카드로 결제하기',
  'checkinpayment.success': '결제 성공',
  'checkinpayment.merchantRef': '거래 번호:',
  'checkinpayment.mini.success': '예약 결제가 성공적으로 완료되었습니다.',
  'checkinpayment.mini.success2':
    '고객님을 맞이할 것을 기대하며, 고객님의 숙박이 원활하고 기억에 남는 경험이 되도록 최선을 다하겠습니다.',
  'checkinpayment.mini.success3': '곧 뵙겠습니다!',
  'checkinpayment.error': '거래 실패, 다시 결제해 주세요.',
  'checkinpayment.bankError': '거래가 거부되었습니다, 은행에 문의해 주세요.',
  'checkinpayment.invoice': '청구서는 귀하의 이메일로 발송됩니다.',
  'checkinpayment.continue': '계속하기',
  'checkinpayment.pleasescanqrcode': '앱으로 QR 코드를 스캔해 주세요.',
  'checkinpayment.payInNewTab': '새 탭에서 결제를 완료해 주세요.',
  'checkinpayment.payInNewTabNotOpened':
    '새 탭이 자동으로 열리지 않으면 아래 버튼을 눌러 시작해 주세요.',
  'checkinpayment.startPayment': '결제 시작하기',

  /** Review */
  'review.title': "예약 세부사항을 확인하시고 '확인' 버튼을 클릭해주세요",
  'review.confirm.no': '예약 번호',
  'review.guest.name': '성함',
  'review.checkin.date': '체크인/체크아웃 날짜',
  'review.reserved.room.type': '룸 타입',
  'review.total.room.rate': '객실 요금 총 비용',
  'review.preferences': '선호 사항',
  'review.note':
    '예약 이름이 신분증/여권과 동일한지 확인해 주세요. 궁금한 점이 있으면 resvn@royalplaza.com.hk로 이메일을 보내주세요.',
  'review.video.note':
    '사전 등록하기 전에 {play} 버튼을 클릭하여 소개 {video}를 시청해 주세요.',
  'review.video.play': '재생',
  'review.video.video': '비디오',
  'review.room.type.RSK': '프리미엄 룸',
  'review.room.type.RST': '프리미엄 룸',
  'review.room.type.RDK': '디럭스 룸',
  'review.room.type.RDT': '디럭스 룸',
  'review.room.type.RDH': '디럭스 룸',
  'review.room.type.RPK': '프리미엄 룸',
  'review.room.type.RPT': '프리미엄 룸',
  'review.room.type.RPH': '프리미엄 룸',
  'review.room.type.CDK': '이그제큐티브 디럭스 룸',
  'review.room.type.CDT': '이그제큐티브 디럭스 룸',
  'review.room.type.CDH': '이그제큐티브 디럭스 룸',
  'review.room.type.CPK': '이그제큐티브 프리미엄 룸',
  'review.room.type.CPT': '이그제큐티브 프리미엄 룸',
  'review.room.type.CPH': '이그제큐티브 프리미엄 룸',
  'review.room.type.STK': '특별 스위트룸',
  'review.room.type.STH': '특별 스위트룸',
  'review.room.type.SJK': '프리미엄 스위트룸',
  'review.room.type.SJT': '프리미엄 스위트룸',
  'review.room.type.SJH': '프리미엄 스위트룸',
  'review.room.type.SDK': '디럭스 스위트룸',
  'review.room.type.SDH': '디럭스 스위트룸',
  'review.room.type.SRK': '로얄 스위트룸',
  'review.room.type.SPK': '프레지덴셜 스위트룸',
  'review.room.type.TDK': '스카이 디럭스 룸',
  'review.room.type.TDH': '스카이 디럭스 룸',
  'review.room.type.THK': '스카이 오션 뷰 룸',
  'review.room.type.THQ': '스카이 오션 뷰 룸',
  'review.room.type.TSK': '스카이 반오션 뷰 룸',
  'review.room.type.TSQ': '스카이 반오션 뷰 룸',
  'review.room.type.HJH': '스카이 프리미엄 스위트룸',
  'review.room.type.HVS': '스카이 오션 뷰 스위트룸',
  'review.room.type.DBD': '프리미엄 룸',
  'review.room.type.TWD': '프리미엄 룸',
  'review.room.type.QEA': '디럭스 룸',
  'review.room.type.TWA': '디럭스 룸',
  'review.room.type.QEE': '프리미엄 디럭스 룸',
  'review.room.type.TWE': '프리미엄 디럭스 룸',
  'review.room.type.KHC': '가족 룸',
  'review.room.type.KHA': '프리미엄 가족 룸',
  'review.room.type.QEC': '프리미엄 플래티넘 룸',
  'review.room.type.TWC': '프리미엄 플래티넘 룸',
  'review.room.type.QEAEF': '디럭스 이그제큐티브 룸',
  'review.room.type.KGAEF': '프리미엄 이그제큐티브 룸',
  'review.room.type.SKC': '버넬 스위트룸',
  'review.room.type.SUP': '프리미엄 더블 룸',
  'review.room.type.AWM': 'Anti-window (4 Ft)',
  'review.room.type.TD': '타워 더블',
  'review.room.type.DLX': '디럭스 룸',
  //DWC
  'review.room.type.SUD': '프리미엄 룸',
  'review.room.type.SUH': '프리미엄 룸',
  'review.room.type.SUK': '프리미엄 룸',
  'review.room.type.SUT': '프리미엄 룸',
  'review.room.type.GCUD': '프리미엄 룸 (뷰 포함)',
  'review.room.type.GCUK': '프리미엄 룸 (뷰 포함)',
  'review.room.type.GCUT': '프리미엄 룸 (뷰 포함)',
  'review.room.type.PDEQ': '프리미엄 코즈웨이 시티 뷰 룸',
  'review.room.type.PDED': '프리미엄 코즈웨이 시티 뷰 룸',
  'review.room.type.PDEK': '프리미엄 코즈웨이 시티 뷰 룸',
  'review.room.type.PDET': '프리미엄 코즈웨이 시티 뷰 룸',
  'review.room.type.PDCK': '프리미엄 팡마이 경마장 뷰 룸',
  'review.room.type.PDCQ': '프리미엄 팡마이 경마장 뷰 룸',
  'review.room.type.PDCT': '프리미엄 팡마이 경마장 뷰 룸',
  'review.room.type.PDCD': '프리미엄 팡마이 경마장 뷰 룸',
  'review.room.type.DTR': '디럭스 트리플 룸',
  'review.room.type.DFQ': '디럭스 패밀리 쿼드 룸',
  'review.room.type.EFQ': '디럭스 패밀리 쿼드 룸',
  'review.room.type.ESK': '이그제큐티브 스위트룸',
  'review.room.type.EST': '이그제큐티브 스위트룸',

  /** Confirm */
  'confirm.title': '도착 전 등록 완료',
  'confirm.reminder':
    '호텔에 도착하시면 게스트 키오스크 셀프 체크인을 이용하실 수 있습니다. ',
  'confirm.reminder.6641bd847063233124b3d922':
    '도착 시 아래 QR 코드를 사용하실 수 있습니다.',
  'confirm.reminder2': '체크인 시 체크인 QR 코드를 보여주세요.',
  'confirm.reminder2.6641bd847063233124b3d922': '',
  'confirm.thankyou': '감사합니다',
  'confirm.qrcode.err': 'QR 코드 값이 올바르지 않습니다.',
  'confirm.notice.title': '특별 안내:',
  'confirm.notice.covid19.title': '신종 코로나바이러스 예방 조치',
  'confirm.notice.covid19.detail': '자세한 내용은 다음을 참조해 주세요:',
  'confirm.notice.covid19.link':
    'https://www.royalplaza.com.hk/hk/precautionary-measures-for-novel-coronavirus/',
  'confirm.notice.policy.title': '개인정보 보호정책 및 면책 조항',
  'confirm.notice.policy.detail': '자세한 내용은 다음을 참조해 주세요:',
  'confirm.notice.policy.link':
    'https://www.royalplaza.com.hk/hk/disclaimer-privacy-statement/',
  'confirm.deposit':
    '체크인 절차를 빠르게 진행하기 위해, 전액 선결제한 고객은 보증금을 지불할 필요가 없습니다. 추가 비용은 직접 지급해야 하며 방 요금에 포함할 수 없습니다.',

  /** Registration Page content */
  'reg.title': '사전 등록',
  'reg.reminder': '아래에 개인정보를 입력하신 후 "확인" 버튼을 클릭해주세요',
  'reg.wechat.reminder': '아래 QR 코드를 스캔해 주세요.',
  'reg.firstName': '이름',
  'reg.familyName': '성함',
  'reg.lastName': '성함',
  'reg.email': '개인 이메일',
  'reg.email.noPersonal': '이메일',
  'reg.address1': '주소 1',
  'reg.address': '주소',
  'reg.address2': '주소 2',
  'reg.pleaseSelect': '선택해주세요',
  'reg.country': '국적',
  'reg.country.noRegion': '국적',
  'reg.state': '도도부현',
  'reg.nationality': '국적',
  'reg.zipCode': '우편 번호',
  'reg.postalCode': '우편 번호',
  'reg.arrivalHrs': '도착 예정 시간',
  'reg.flightArrival.time': '항공편 도착 시간 / 예상 도착 시간',
  'reg.arrival.hr': '시',
  'reg.arrival.min': '분',
  'reg.arrival.subject': '공급 상황에 따라 다릅니다',
  'reg.tel': '전화번호',
  'reg.passportNumber': '여권 번호',
  'reg.dateOfBirth': '생년월일',
  'reg.flightNumber': '항공편 번호',
  'reg.flightArrivalTime': '도착 시간',
  'reg.evoucher':
    '호텔 프로모션 및 할인 정보 수신 (이메일, 문자 및 소셜 미디어를 통해)',
  'reg.evoucher.yes/no': '수락/거부',
  'reg.evoucher.yes': '수락',
  'reg.evoucher.no': '거부',
  'reg.method.inst.msg': '즉시 통신 방법',
  'reg.method.inst.msg.select': '통신 방식을 선택해 주세요',
  'reg.method.inst.msg.sms': '문자',
  'reg.method.inst.msg.email': '이메일',
  'reg.method.inst.msg.whatsapp': 'WhatsApp',
  'reg.method.inst.msg.wechat': '위챗',

  'hdf.ask': '건강 신고서를 작성하시겠습니까?',
  'hdf.title': '건강 신고서',
  'hdf.highRiskWarning.title': '검토 내용',
  'hdf.highRiskWarning.message':
    '내용을 다시 검토하시거나 호텔에 연락하여 추가 도움을 받으세요.',
  'hdf.sign.title': '제가 기재한 정보는 모두 사실입니다.',
  'hdf.sign.text': '아래에 서명해 주세요:',
  'hdf.sign.clear': '지우기',

  'hdf.btn.fill': '작성하기',
  'hdf.btn.addGuest': '게스트 추가',
  'hdf.btn.signAndConfirm': '서명 및 확인',
  'hdf.btn.submitForm': '확인',
  'hdf.btn.back': '뒤로',
  'hdf.btn.backToReview': '등록으로 돌아가기',

  'hdf.guestName': '고객 이름',
  'hdf.accompanyName': '동행인',
  'hdf.familyName': '성',
  'hdf.firstName': '이름',
  'hdf.dateOfBirth': '생년월일',
  'hdf.sex': '성별',
  'hdf.sex.m': '남',
  'hdf.sex.f': '여',
  'hdf.passport': '여권/신분증 번호',
  'hdf.nationality': '국적 지역',
  'hdf.comeFrom': '여행 출발지',
  'hdf.arrivalDate': '도착 날짜',
  'hdf.placesVisitedInSevenDays':
    '지난 7일 동안 방문한 국가 및 도시를 기재해 주세요.',
  'hdf.contactWithCovid': '지난 7일간 확진자와 접촉한 적이 있습니까?',
  'hdf.contactWithCovid.yes': '예',
  'hdf.contactWithCovid.no': '아니오',
  'hdf.symptom': '다음 증상이 있습니까?',
  'hdf.symptom.no': '아니오',
  'hdf.symptom.fever': '발열',
  'hdf.symptom.breathingDifficulty': '호흡 곤란',
  'hdf.symptom.cough': '기침',
  'hdf.symptom.diarrhoea': '설사',
  'hdf.symptom.headache': '두통',
  'hdf.symptom.musclePain': '근육통',
  'hdf.symptom.runnyNose': '콧물',
  'hdf.symptom.soreThroat': '인후통',
  'hdf.symptom.stuffyNose': '코 막힘',
  'hdf.symptom.vomiting': '구토',
  'hdf.contact': '향후 7일간의 연락 방법',
  'hdf.contact.phone': '전화/휴대폰 번호',
  'hdf.email': '이메일',
  'hdf.address': '연락 주소',
  'btn.confirm': '확인',
  'btn.hdf.form': '건강 신고서',
  'btn.reset': '초기화',
  'btn.cancel': '취소',
  'btn.identityCard': '신분증',
  'btn.passport': '여권',
  'btn.take': '사진 촬영',
  'btn.upload': '업로드',
  'btn.capture': '촬영',
  'btn.retake': '다시 찍기',
  'btn.reUpload': '다시 업로드',
  'btn.retry': '재시도',
  'btn.register': '등록',
  'btn.remove': '제거',
  'btn.addGuest': '동행 손님',

  /** Document */
  'selectDocumentType.title': '여권 또는 신분증을 선택해 주세요',
  'takeDocumentPhoto.title': '증명서 사진 제출(정면)',
  'takeDocumentPhoto.noteTitle': '촬영 팁',
  'takeDocumentPhoto.note1': '1. 환경이 너무 어둡거나 흐릿하지 않도록 하세요.',
  'takeDocumentPhoto.note2': '2. 텍스트 및/또는 이미지가 보이도록 하세요.',
  'takeDocumentPhoto.note3': '3. 이미지가 선명하고 흐릿하지 않도록 하세요.',
  'takeDocumentPhoto.takePhotoInstruction1':
    '모든 정보가 프레임 안에 있도록 이미지를 조정하세요.',
  'takeDocumentPhoto.takePhotoInstruction2': '신분증을 프레임 안에 넣으세요.',
  'takeDocumentPhoto.takePhotoInstruction3':
    '휴대전화를 세로 방향으로 들고 촬영하세요.',
  'takeDocumentPhoto.uploadSuccess': '업로드 성공',
  'takeDocumentPhoto.uploadFail': '업로드 실패',
  'takeDocumentPhoto.uploading': '업로드 중... 잠시 기다려 주세요',

  /** Add Guest */
  'accompanyGuest.title': '동행 손님',
  'accompanyGuest.label.guestName': '성함',
  'accompanyGuest.label.lastName': '성함',
  'accompanyGuest.label.firstName': '이름',
  'accompanyGuest.guestStatus.completed': '완료',
  'accompanyGuest.guestStatus.inProgress': '미등록',
  'accompanyGuest.removeGuest.confirmation': '이 손님을 삭제하시겠습니까?',

  /** Modal */
  'modal.title.removeGuest': '손님 제거',
};
